/** @module components/UploadMessage */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@devowl-wp/react-folder-tree";
import { Progress } from ".//index.js";
import { injectAndObserve } from "../store/index.js";
import { i18n, resolveIcon } from "../util/index.js";
/**
 * Show the current uploading file with progress bar and status. It uses
 * the main store to read the current upload.
 *
 * @type React.Element
 */ export default injectAndObserve(({ store, onCancel })=>{
    const { currentUpload, uploadTotalRemainTime, readableUploadTotalLoaded, readableUploadTotalSize, readableUploadTotalBytesPerSec } = store;
    if (!currentUpload) {
        return null;
    }
    const { name, previewSrc, percent, readableLoaded, readableSize, deny, relativePathBasename, icon } = currentUpload;
    const count = store.uploading.length;
    return /*#__PURE__*/ _jsxs("span", {
        className: "rml-upload",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rml-upload-trigger",
                children: [
                    !!previewSrc && /*#__PURE__*/ _jsx("div", {
                        className: "rml-upload-image",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: previewSrc
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rml-upload-container",
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                className: "rml-upload-file",
                                children: name
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "rml-upload-folder",
                                children: [
                                    resolveIcon(icon),
                                    " ",
                                    relativePathBasename
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Progress, {
                                percent: percent,
                                size: "small",
                                status: percent >= 100 ? "success" : "active"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "rml-upload-progress",
                                children: [
                                    count > 1 && /*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            i18n("filesRemaining", {
                                                count
                                            }),
                                            " \xb7\xa0"
                                        ]
                                    }),
                                    percent >= 100 ? i18n("receiveData") : /*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            readableLoaded,
                                            " / ",
                                            readableSize
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    uploadTotalRemainTime,
                                    " \xb7 ",
                                    readableUploadTotalBytesPerSec,
                                    "/s\xa0",
                                    count > 1 ? /*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            "\xb7 ",
                                            readableUploadTotalLoaded,
                                            " / ",
                                            readableUploadTotalSize
                                        ]
                                    }) : ""
                                ]
                            }),
                            !!deny && /*#__PURE__*/ _jsxs("div", {
                                className: "rml-upload-deny",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        type: "warning"
                                    }),
                                    " ",
                                    deny
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rml-upload-cancel",
                onClick: onCancel,
                children: i18n("cancel")
            })
        ]
    });
});
